import { useQuery } from '@tanstack/react-query'
import { listIndeedFlexClients } from 'api/admin/indeedFlex/listIndeedFlexClients'
import { indeedFlexKeys } from './keys'

export function useIndeedFlexClientsQuery() {
  return useQuery({
    queryKey: indeedFlexKeys.clients(),
    queryFn: listIndeedFlexClients,
  })
}
